import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Breadcrumbs from '../../layout/Breadcrumbs';
import { Link } from 'react-router-dom';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Navigation, Autoplay } from "swiper/modules";

// Dummy data for your portfolio items
// You could fetch these from an API or define them elsewhere
const portfolioItems = [
  {
    id: 1,
    category: ['cms' , 'react'],
    image: './assets/images/success-stories/product-1.jpg',
    link: '/project-details/1', // Internal Link
    title: 'Club Portal',
    description: 'Customizable teamwear for clubs'
  },
  {
    id: 2,
    category: ['cms' , 'react'],
    image: './assets/images/success-stories/product-2.jpg',
    link: '/project-details/2', // Internal Link
    title: 'DBS',
    description: 'Dealer Bussiness Software'
  },
  {
    id: 3,
    category: 'design',
    image: './assets/images/success-stories/product-3.jpg',
    link: '/project-details/3', // Internal Link
    title: 'Aplus Autism',
    description: 'Learning Management System (LMS)'
  },
  {
    id: 4,
    category: 'development',
    image: './assets/images/success-stories/product-4.jpg',
    link: '/project-details/4',
    title: 'Microfinance',
    description: 'Loan Management System'
  },
  {
    id: 5,
    category: 'api',
    image: './assets/images/success-stories/product-5.jpg',
    link: '/project-details/5', // Internal Link
    title: 'XeroInvoiceAPI',
    description: 'Rental Management System with Xero'
  },
  {
    id: 6,
    category: 'development',
    image: './assets/images/success-stories/product-6.jpg',
    link: '/project-details/6',
    title: 'Digital CRM',
    description: 'Influencer CRM'
  },
  {
    id: 7,
    category: 'development',
    image: './assets/images/success-stories/product-7.jpg',
    link: '/project-details/7',
    title: 'MacyCloud',
    description: 'Precision Fabricated Machine Parts'
  },
  {
    id: 8,
    category: 'development',
    image: './assets/images/success-stories/product-8.jpg',
    link: '/project-details/8',
    title: 'PetCare',
    description: 'Pet Reservation Online'
  },

  {
    id: 9,
    category: 'development',
    image: './assets/images/success-stories/product-9.jpg',
    link: '/project-details/9', // Internal Link
    title: 'CERFAM',
    description: 'Knowledge Exchange Platform (KEPT)'
  },
  {
    id: 10,
    category: ['cms' , 'react'],
    image: './assets/images/success-stories/product-10.jpg',
    link: '/project-details/10',
    title: 'Lifia',
    description: 'Technology to improve your healthcare'
  },
  {
    id: 11,
    category: 'react',
    image: './assets/images/success-stories/product-11.jpg',
    link: '/project-details/11',
    title: 'Viberent',
    description: 'Rental Management & Online Booking'
  },
  {
    id: 12,
    category: 'wordpress',
    image: './assets/images/success-stories/product-12.jpg',
    link: '/project-details/12',
    title: "Lentorcentralresidences",
    description: "Lentor Central Residences",
  },

  {
    id: 13,
    category: 'wordpress',
    image: './assets/images/success-stories/product-13.jpg',
    link: '/project-details/13',
    title: 'W8CED',
    description: 'Ward8 Community Economic'
  },

  {
    id: 14,
    category: 'wordpress',
    image: './assets/images/success-stories/product-14.jpg',
    link: '/project-details/14',
    title: 'SEDSERVER',
    description: 'Trusted legal document Service'
  },
  
  {
    id: 15,
    category: 'react',
    image: './assets/images/success-stories/product-15.jpg',
    link: '/project-details/15',
    title: 'GotTickets',
    description: 'Sell your event Tickets Online'
  },

  {
    id: 16,
    category: 'react',
    image: './assets/images/success-stories/product-16.jpg',
    link: '/project-details/16',
    title: 'OnTopic',
    description: 'Lets start talking with OnTopic'
  },

];


const commonImages = [
{
  image: "/assets/images/success-stories/product-courier.jpg",
  title: "Courier",
  description: "Overseas Express Courier",
},
{
  image: "/assets/images/success-stories/product-rentalsaas.jpg",
  title: "Rental Saas",
  description: "Rental Management System",
},
{
  image: "/assets/images/success-stories/product-healthcare.jpg",
  title: "Health Care",
  description: "Patient Portal",
},
{
  image: "./assets/images/success-stories/product-aqualog.jpg",
  title: "Aqualog",
  description: "Digital Logging System",
},
{
  image: "./assets/images/success-stories/product-TMSVJU.jpg",
  title: "TMS VJU",
  description: "Task management system",
},
{
  image: "./assets/images/success-stories/product-truegroups.jpg",
  title: "Truegroups",
  description: "HR Management System",
},
{
  image: "./assets/images/success-stories/product-portermark.jpg",
  title: "Portermark",
  description: "Franchise management system",
},
]


function  Portfolio({ showBreadcrumbs = true }) {
  // Initialize AOS if you’re using Animate On Scroll
  useEffect(() => {
    AOS.init({ 
      duration: 1000, 
      offset: 50, 
      easing: "ease-in-out", 
      once: true 
    });
  }, []);

  // Track the current filter in state
  const [filter, setFilter] = useState('all');

  // Available filters (including "all")
  const filters = [
    { key: 'all', label: 'All' },
    { key: 'design', label: 'Design' },
    { key: 'development', label: 'Web Development' },
    { key: 'react', label: 'React / Angular' },
    { key: 'cms', label: 'CMS' },
    { key: 'wordpress', label: 'WordPress' },
    { key: 'api', label: 'Api' }

  ];

  // Filter portfolio items
  const filteredItems = portfolioItems.filter((item) => {
    return filter === 'all' || item.category.includes(filter);
  });

  return (
    <>
    {/* Conditionally render Breadcrumbs */}
    {showBreadcrumbs && (
      <Breadcrumbs
        pageTitle="Case Studies"
        pageSubtitle="Our commitment to quality exceeds expectations. Take a look at some of our trusted clients."
        activePage="Success Stories"
      />
    )}
    <div className="portfolio" id="protofolio">
      
      <div
        className="container"
        data-aos="fade-up"
        data-portfolio-filter="*"
        data-portfolio-layout="masonry"
        data-portfolio-sort="original-order"
        data-aos-delay="100"
      >
        {/* Filter Buttons */}
        <div className="filter-buttons" data-aos="fade-right">
            {filters.map((f) => (
              <button key={f.key} className={filter === f.key ? "active" : ""} onClick={() => setFilter(f.key)}>
                {f.label}
              </button>
            ))}
          </div>

        {/* Portfolio Grid */}
        <div className="grid">
          {filteredItems.map((item) => (
            <div
              key={item.id}
              className="project-card"
              data-category={item.category}
              data-aos="zoom-in">
              {/* If there's a link, wrap the image in <a> */}
              {item.link.startsWith('http') ? (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={item.image} alt={item.title} />
                  <div className="overlay-item">
                    <i className="fas fa-link"></i>
                  </div>
                </a>
              ) : (
                // If there's no link, just show the image
                <Link to={item.link}>
                  <img src={item.image} alt={item.title} />
                  <div className="overlay-item">
                    <i className="fas fa-link"></i>
                  </div>
                </Link>
              )}

              {/* Info */}
              <div className="project-info" data-aos="fade-up">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>

            </div>
          ))}
        </div>
        </div>
        
              
   
    </div>

    <div className="container-fluid p-3" data-aos="fade-up">
      {/* Project Images Slider */}
      <div className="row">
        <div className="col-md-12 project-slider-block" data-aos="zoom-in">
          {commonImages.length > 0 && (
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              speed={800}
              loop={true}
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{
                400: { slidesPerView: 2 },
                600: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
              }}
              className="project-slider"
            >
              {commonImages.map((item, index) => (
                <SwiperSlide key={index} data-aos="flip-left">
                  <div className="project-slide">
                    <img
                      src={item.image}
                      alt={item.title}
                      title={item.title}
                      className="project-image border rounded shadow-sm img-fluid"
                      loading="lazy"
                    />
                    <div className="project-info" data-aos="fade-up">
                      <h5 className="project-title">{item.title}</h5>
                      <p className="project-description">{item.description}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div>
    </div>
    </> 
  );
 
}

export default Portfolio;
